const DATE_OPTIONS = {
  short: { year: 'numeric', month: 'short', day: 'numeric' },
  long: { year: 'numeric', month: 'long', day: 'numeric' },
  withTime: {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  },
};

export function formatDate(dateString, style = 'short') {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', DATE_OPTIONS[style] || DATE_OPTIONS.short);
}

export function formatEnrolledAt(dateString) {
  const date = new Date(dateString);
  return {
    date: `${date.toLocaleDateString('en-US', DATE_OPTIONS.short)},`,
    time: date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
    }),
  };
}
